module.exports = __webpack_public_path__ + "public/images/learn-chinese.806a6ead51b3d3488cda60277328c725.jpg";